export default __webpack_public_path__ + "static/media/Caritas_int_be_rouge_blanc@2x.02777f78.png";